export default {
  "class-order": "error",
  "class-wrap": "error",
};
